import React, {useState, useContext, useEffect} from "react";
import {
   BodyForm,
   ContainerButtons,
   ButtonOption,
   SubtitleAuth,
   InputAuth,
   LabelAuth,
   MultiComponent,
   SectionSeparator,
   LabelLinks,
} from "./AuthStyles";
import Checker from "./Checker";
import Select from "../../../components/Select";
import Color from "../../../assets/Colors";
import Text from "../../../styles/Text";
import styled from "styled-components";
import {GlobalContext} from "../../../context/GlobalContext";
import {LoadComponet} from "../../../components/loaders/Loader";
import {useLocation} from "react-router-dom";
import CitiesSelect from "./CitiesSelect";

export default function GetDataComponent({errorsList}) {
   const {userData} = useContext(GlobalContext);
   const [Days] = useState(createArrayNumbers(1, 31));
   const [Months] = useState(createArrayNumbers(1, 12));
   const [Years] = useState(createArrayNumbers(new Date().getFullYear() - 90, 90 - 17).reverse());
   const [prevData, setPrevData] = useState({first_name: "", last_name: "", email: ""});
   const [registerType, setRegisterType] = useState(3);
   let location = useLocation();

   useEffect(() => {
      if (location.state) {
         let newPev = location.state.prevData;
         // console.log(newPev);
         setPrevData(newPev);

         let prevType = location.state.type || 3;
         setRegisterType(prevType);
      }
   }, [location]);

   const isError = (name) => {
      let findName = errorsList.find((er) => er.name === name);
      return findName ? "error" : "";
   };

   if (!userData) return <LoadComponet isVisible={true} />;
   return (
      <>
         <BodyForm>
            <SubtitleUpdate transform="uppercase">Información personal</SubtitleUpdate>

            {/* <LabelAuth>Nombre:</LabelAuth> */}
            <InputAuth placeholder="Nombre*" type="text" defaultValue={prevData.first_name} required name="name" />

            {/* <LabelAuth>Apellido:</LabelAuth> */}
            <InputAuth placeholder="Apellido*" type="text" defaultValue={prevData.last_name} required name="userLastName" />

            <MultiComponent>
               <LabelAuth className="noMargin">*Fecha de nacimiento:</LabelAuth>
               <div className="inputMin">
                  <Select id="dateDay" name="dateDay" placeholder={{value: "0", name: "DD"}} options={Days} />
               </div>
               <div className="line" />
               <div className="inputMin">
                  <Select id="dateMonth" name="dateMonth" placeholder={{value: "0", name: "MM"}} options={Months} />
               </div>
               <div className="line" />
               <div className="inputMin year">
                  <Select id="dateYear" name="dateYear" placeholder={{value: "0", name: "YYYY"}} options={Years} />
               </div>
            </MultiComponent>

            <MultiComponent>
               <LabelAuth className="noMargin">*Sexo:</LabelAuth>
               <Checker type="radio" name="idSex" value="1" title="H" defaultChecked={Number(userData.idSex) === 1} />
               <Checker type="radio" name="idSex" value="2" title="M" defaultChecked={Number(userData.idSex) === 2} />
            </MultiComponent>

            <MultiComponent>
               <LabelAuth className="noMargin">*Ciudad:</LabelAuth>
               <CitiesSelect defaultCity={userData.city} />
            </MultiComponent>

            <SectionSeparator />

            <SubtitleUpdate transform="uppercase">eXPRECIENCIA profesional</SubtitleUpdate>

            <LabelAuth>¿Tienes experiencia en la industria:</LabelAuth>
            <Select
               id="certified"
               name="industryExperience"
               defaultValue={userData.idExpYears}
               options={[
                  {value: 1, name: "1 a 3 años"},
                  {value: 2, name: "3 a 5 años"},
               ]}
            />
            {/* <Select id="certified" name="certified" options={[{value: "1", name: "De 1 a 3 años"}]} /> */}

            <SectionSeparator />

            {registerType !== 3 && (
               <>
                  <InputAuth defaultValue={prevData.email} name="email" type="hidden" />
                  <InputAuth defaultValue={prevData.pwd} name="pwd" type="hidden" />
                  <InputAuth defaultValue={prevData.pwd} name="pwdConfirm" type="hidden" />
                  <InputAuth defaultValue={1} name="idSecurityQuestion" type="hidden" />
                  <InputAuth defaultValue="fb_login" name="securityAnswer" type="hidden" />
                  <InputAuth defaultValue={registerType} name="idRegisterType" type="hidden" />
               </>
            )}

            {registerType === 3 && (
               <>
                  <InputAuth defaultValue={3} name="idRegisterType" type="hidden" />
                  <SubtitleUpdate transform="uppercase">Información de registro</SubtitleUpdate>

                  {/* <LabelAuth>* Email:</LabelAuth> */}
                  <InputAuth
                     placeholder="Mail*"
                     type="email"
                     required
                     name="email"
                     className={isError("email")}
                     defaultValue={userData.email}
                  />

                  {/* <LabelAuth>* Contraseña:</LabelAuth> */}
                  <InputAuth
                     placeholder="Contraseña*"
                     type="password"
                     required={false}
                     name="pwd"
                     className={isError("password")}
                     autocomplete="off"
                  />

                  {/* <LabelAuth>* Confirmar contraseña:</LabelAuth> */}
                  <InputAuth
                     placeholder="Confirmar contraseña*"
                     type="password"
                     name="pwdConfirm"
                     required={false}
                     className={isError("password")}
                     autocomplete="off"
                  />

                  {/* <LabelAuth className="bottomMargin">* Pregunta de seguridad:</LabelAuth> */}

                  <Select
                     id="question"
                     name="idSecurityQuestion"
                     defaultValue={userData.idSecurityQuestion}
                     placeholder={{value: "0", name: "Selecciona una pregunta de seguridad"}}
                     options={[
                        {value: 1, name: "Nombre de primera mascota:"},
                        {value: 6, name: "Materia favorita:"},
                        {value: 2, name: "¿Cuál es tu comida favorita?"},
                        {value: 3, name: "¿Cuál es el apellido de tu abuela materna?"},
                        {value: 4, name: "¿Cuál es el apellido de tu abuela paterna?"},
                        {value: 5, name: "¿Cuál fue el nombre de tu primaria?"},
                     ]}
                  />

                  {/* <LabelAuth>* Respuesta:</LabelAuth> */}
                  <InputAuth
                     placeholder="Escribe la respuesta a la pregunta de seguridad*"
                     defaultValue={userData.securityAnswer}
                     type="text"
                     required
                     name="securityAnswer"
                  />
               </>
            )}

            <MultiComponent>
               <Checker type="checkbox" name="newsletter" value="newsletter" title="Deseo suscribirme al newsletter" />
            </MultiComponent>

            <ErrorContainer>
               {errorsList &&
                  React.Children.toArray(
                     errorsList.map((item) => {
                        if (!item.text) return null;
                        return (
                           <Text color="crimson" as="li">
                              {item.text}
                           </Text>
                        );
                     }),
                  )}
            </ErrorContainer>

            <ContainerButtons width="40%">
               <ButtonOption className="widthAuto">Crear cuenta</ButtonOption>
            </ContainerButtons>

            <ContainerButtons width="100%">
               <LabelLinks as="label" color={Color.textColor} decoration="none">
                  Al dar click en crear cuenta el usuario acepta los{" "}
                  <LabelLinks color={Color.textColor} to="?terms=true">
                     TÉRMINOS Y CONDICIONES{" "}
                  </LabelLinks>{" "}
                  así como las{" "}
                  <LabelLinks color={Color.textColor} to="?privacy=true">
                     POLÍTICAS DE PRIVACIDAD DEL SITIO{" "}
                  </LabelLinks>{" "}
                  del sitio.
               </LabelLinks>
            </ContainerButtons>
         </BodyForm>
      </>
   );
}

function createArrayNumbers(start, item) {
   let base = new Array(item).fill("x");
   let toReturn = Object.keys(base).map((x) => {
      let option = {value: start + Number(x), name: start + Number(x)};
      return option;
   });
   return toReturn;
}

const SubtitleUpdate = styled(SubtitleAuth)`
   color: ${Color.primary};
`;

/* const LabelAuth = styled(LabelAuth)`
   color: ${Color.primary};
   font-weight: 400;
   padding-bottom: 0;
   padding-top: 0;
   margin-top: 1.5em;

   &.noMargin {
      margin-top: 0;
   }

   &.bottomMargin {
      margin-bottom: 1em;
   }
`;
 */
const ErrorContainer = styled.ul`
   margin-top: 1em;

   & li {
      margin-top: 0.2em;
      font-size: 1.2em;
   }

   @media screen and (max-width: 1600px) {
      & li {
         margin-top: 0.2em;
         font-size: 0.9em;
      }
   }
`;

/*<SubtitleUpdate transform="uppercase">experiencia profesional</SubtitleUpdate>

<LabelAuth>¿Tienes experiencia en la industria?</LabelAuth>

<MultiComponent>
  <Checker type="radio" name="experience" value="1" title="Sí" />
  <Checker type="radio" name="experience" value="0" title="No" />
</MultiComponent>

<LabelAuth margin="2em 0 0 0">¿Tienes alguna certificación?</LabelAuth>
<Select id="hasCertified" name="hasCertified" />
<MultiComponent>
  <LabelAuth>Especifica: </LabelAuth>
  <Select id="certified" name="certified" />
</MultiComponent>*/
